// SPDX-License-Identifier: GPL-3.0-or-later
import type { IceServer } from '@ffb/shared';

export type { IceServer };

// Fallback: публичные STUN, чтобы клиент хотя бы пытался прямое P2P при недоступном бэке.
// В норме этот список приходит с /turn-credentials.
export const FALLBACK_ICE_SERVERS: IceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
];
